// Small behaviours for the server-rendered pages: flash toasts, copy-to-
// clipboard buttons, and reveal toggles for masked values. Everything is
// delegated from document so Turbo page swaps need no re-initialisation.

const FLASH_AUTO_DISMISS_MS = 6000;

function fadeOut(element) {
  element.style.transition = "opacity 300ms ease";
  element.style.opacity = "0";
  window.setTimeout(() => element.remove(), 320);
}

// Success toasts fade out on their own; alerts stay until dismissed.
function scheduleFlashDismissal() {
  document.querySelectorAll('[data-flash][data-flash-type="notice"]:not([data-flash-scheduled])').forEach((toast) => {
    toast.dataset.flashScheduled = "true";
    window.setTimeout(() => fadeOut(toast), FLASH_AUTO_DISMISS_MS);
  });
}

function copyViaSelection(text) {
  const helper = document.createElement("textarea");
  helper.value = text;
  helper.setAttribute("readonly", "");
  helper.style.position = "fixed";
  helper.style.opacity = "0";
  document.body.appendChild(helper);
  helper.select();
  const copied = document.execCommand("copy");
  helper.remove();
  if (!copied) throw new Error("copy command rejected");
}

async function copyText(text) {
  // The async clipboard API can be denied by permissions policy or an
  // insecure context; the selection-based fallback still works there.
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // fall through
    }
  }
  copyViaSelection(text);
}

function handleCopyClick(button) {
  const text = button.dataset.copy;
  if (!text) return;

  const label = button.querySelector("[data-copy-label]") || button;
  const originalLabel = label.textContent;

  copyText(text)
    .then(() => {
      label.textContent = button.dataset.copiedLabel || "Copied";
      button.setAttribute("aria-live", "polite");
      window.setTimeout(() => {
        label.textContent = originalLabel;
      }, 1800);
    })
    .catch(() => {
      label.textContent = "Copy failed";
      window.setTimeout(() => {
        label.textContent = originalLabel;
      }, 1800);
    });
}

function handleRevealClick(button) {
  const target = document.getElementById(button.dataset.revealTarget);
  if (!target) return;

  const revealed = target.dataset.revealed === "true";
  target.dataset.revealed = revealed ? "false" : "true";
  target.textContent = revealed ? target.dataset.masked : target.dataset.value;
  button.textContent = revealed ? button.dataset.showLabel || "Show" : button.dataset.hideLabel || "Hide";
  button.setAttribute("aria-pressed", revealed ? "false" : "true");
}

document.addEventListener("click", (event) => {
  const dismiss = event.target.closest("[data-flash-dismiss]");
  if (dismiss) {
    dismiss.closest("[data-flash]")?.remove();
    return;
  }

  const copy = event.target.closest("[data-copy]");
  if (copy) {
    event.preventDefault();
    handleCopyClick(copy);
    return;
  }

  const reveal = event.target.closest("[data-reveal-target]");
  if (reveal) {
    event.preventDefault();
    handleRevealClick(reveal);
  }
});

document.addEventListener("turbo:load", scheduleFlashDismissal);
scheduleFlashDismissal();
